import { IconStar, IconStarFilled } from '@tock/icons';
import { ratingBase, ratingSize } from 'components/inputs/fiveStarFieldCssDefs';
import Rating, { RatingProps } from '@material-ui/lab/Rating';

export interface FiveStarFieldProps extends RatingProps {
  size?: 'small' | 'medium';
}

export const FiveStarField = ({ readOnly, size = 'medium', ...rest }: FiveStarFieldProps) => {
  return (
    <Rating
      css={[ratingBase, ratingSize(size)]}
      precision={1}
      icon={<IconStarFilled fontSize="inherit" />}
      emptyIcon={<IconStar fontSize="inherit" />}
      readOnly={readOnly}
      size={size}
      {...rest}
    />
  );
};
